import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Table } from '../../components/table/Table';
import {
  actions as duxActions,
  selectors,
} from '../../store/dux/field-boundary-management-dux';

export function Tab(props) {
  const { type, columns, isActive, renderTabs, renderActions } = props;
  const dispatch = useDispatch();
  const fields = useSelector(selectors[`${type}Fields`]);
  const selectedFields = useSelector(selectors.selectedFields);
  const contractOverrides = getContractRequirements(type);

  if (isActive) {
    return (
      <>
        {buildHeader()}
        {buildTable()}
      </>
    );
  }

  function buildHeader() {
    return (
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Box sx={{ flex: 1 }}>{renderTabs()}</Box>
        <Box sx={{ mr: 1 }}>{renderActions?.()}</Box>
      </Box>
    );
  }

  function buildTable() {
    return (
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          '& .MuiDataGrid-row.error': { color: '#aaa' },
        }}
      >
        <Table
          hideFooter={false}
          checkboxSelection
          rowSelectionModel={selectedFields}
          onRowSelectionModelChange={(ids) =>
            dispatch(duxActions.setSelectedFields(ids))
          }
          onRowClick={({ id }) => dispatch(duxActions.toggleFieldFocus(id))}
          disableRowSelectionOnClick
          columns={columns}
          fields={fields || []}
          loading={!fields}
          localeText={{
            noRowsLabel: `No ${type} fields`,
            footerTotalRows: `Total ${type}:`,
          }}
          initialState={{
            sorting: { sortModel: [{ field: 'fieldName', sort: 'asc' }] },
          }}
          {...contractOverrides}
        />
      </Box>
    );
  }
}
function getContractRequirements(type) {
  return type === 'certified'
    ? { allowContractSelection: true }
    : { allowContractSelection: true, hideContractErrorIcon: true };
}
